import { Company } from '@/api';
import { ReactElement, ReactNode } from 'react';
import { CompanyContext, CompanyContextData } from './context';

type CompanyContextProviderProps = {
    readonly company: Company;
    readonly children?: ReactNode;
};

export function CompanyContextProvider({
    company,
    children
}: CompanyContextProviderProps): ReactElement {
    const value: CompanyContextData = {
        company
    };

    return (
        <CompanyContext.Provider value={value}>
            {children}
        </CompanyContext.Provider>
    );
}
